export enum InsurerEnum {
  QUANTUM = 'QUANTUM',
  CHUBB = 'CHUBB',
  CREDIT_LIFE = 'CREDIT_LIFE',
  IPTIQ = 'IPTIQ',
  BNP = 'BNP',
  ZURICH = 'ZURICH',
}
